/* eslint-disable import/no-anonymous-default-export */
import Divider from "../../baseComponents/divider/Divider";
import Section from "../../baseComponents/section/Section";
import { useTranslation } from "react-i18next";
export default (
) => {
    const { t } = useTranslation();

    return (

        <Divider cl="bg-[url('/src/asset/bg8.jfif')]   bg-cover">
            <div className="grid lg:grid-cols-2 md:gap-x-8 md:h-screen  items-center  md:pt-0">
                <div className="w-full  flex justify-center items-center " >

                    <Section title={t("How_use")} text={t("How_use_T")} cl={" md:text-3xl xl:text-[80px] xl:leading-none"} ic={true} />
                </div>
                <div className=" relative w-full  md:h-screen flex justify-center items-center   "  >
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="h-3/4 rounded-[32px] overflow-hidden"
                    >
                        <source src="/applepay.mp4" type="video/mp4" className="h-96" />
                    </video>
                </div>
            </div>
        </Divider>
    );
};
